/* eslint-disable new-cap */
/* eslint-disable camelcase */
import Phaser from 'phaser';
import BasicSprite from '../BasicSprite';
import PlayerSpaceship_Vertical from './PlayerShip_Vertical';
import { Tweens } from '@abcya/abcya_phaser';

export default class Planet {
  /**
   * 
   * @param {Phaser.Scene} scene 
   */
  constructor(scene) {
    this.scene = scene;

    this.posX = this.scene.scale.width * .5;
    this.posY = this.scene.scale.height + 230;

    this.planet = this.scene.add.container(this.posX, this.posY + 200);

    this.planetGraphic = new BasicSprite(this.scene, 0, 0, 'planet');
    this.scene.add.existing(this.planetGraphic);
    this.planet.add(this.planetGraphic);

    this.spaceShip = new PlayerSpaceship_Vertical(this.scene, this.planet, this.planetGraphic.getTopCenter());

    this.planet.angle = 90;

    // if (this.scene.isWidescreen) {
    //   this.planetGraphic.scale.setTo(.7);
    //   this.posY -= 250;
    // }

    this.animateIn();
  }

  animateIn() {
    Tweens.addTween(this.planet, 1000, { y: this.posY }, Phaser.Math.Easing.Back.Out);
    Tweens.addTween(this.planet, 1000, { angle: 0 }, Phaser.Math.Easing.Back.Out, () => {this.randTween();});
  }

  AnimateOut() {
    this.spaceShip.TakeOff();
  }

  Update() {
    this.spaceShip.Update();
  }

  randTween() {
    const randX = (Math.random() * 20) - 10;
    const randY = (Math.random() * 20) - 10;

    Tweens.addTween(this.planet, 3000, { y: this.posY + randY, x: this.posX + randX }, Phaser.Math.Easing.Quadratic.InOut, () => {
      this.randTween();
    });
  }
}


